/*
  Reusable functions for dealing with React refs.
 */


/*
  Use this function as a value of a ref callback
  if all you want to do is focus on that element on mount.

  e.g.

  <div ref={focusOnMount} />
 */
export const focusOnMount = (element) => {
  if (element) {
    element.focus();
  }
};
